export default __webpack_public_path__ + "b34850ed5e5bb454064356ab1f767bd0.svg";